import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'bill',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'list',
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
  { path: 'bill', loadChildren: './pages/bill/bill.module#BillPageModule' },
  { path: 'bill-pay', loadChildren: './pages/bill-pay/bill-pay.module#BillPayPageModule' },
  { path: 'payment-confirmation', loadChildren: './pages/payment-confirmation/payment-confirmation.module#PaymentConfirmationPageModule' }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
